<template>
  <v-flex xs12>
    <v-card flat style="position: relative">
      <div class="close-btn">
        <v-btn @click="$emit('closeModal', true)" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-card flat>
              <div style="position: relative">
                <v-img
                  height="120"
                  contain
                  class="mx-5"
                  :src="publications.sponsor.image"
                ></v-img>
                <v-btn
                  style="bottom: -15px; background-color: #fff !important"
                  @click="openSponsorLink()"
                  color="grey"
                  absolute
                  right
                  outline
                  small
                  flat
                  round
                >
                  visitar site
                </v-btn>
              </div>
              <v-divider />
              <v-card-text>
                <v-list dense>
                  <v-list-tile
                    v-for="(item, key) in publications.groups"
                    :inactive="item === selectedPublication"
                    @click="setSelected(item)"
                    :class="
                      item === selectedPublication ? 'v-list__tile--active' : ''
                    "
                    :key="key"
                  >
                    {{ item }}
                  </v-list-tile>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md9>
            <v-layout wrap row class="pt-5">
              <v-flex
                xs12
                md6
                v-for="(item, key) in selectedPublications"
                :key="key"
              >
                <v-card elevation="1" class="border card-rounded ma-2">
                  <v-card-title>
                    <div>
                      <Icon :name="getIcon(item)" class="mr-3" />
                    </div>
                    <div style="width: calc(100% - 55px)">
                      <span>{{ item.itemTitle }}</span>
                    </div>
                  </v-card-title>

                  <div v-if="isYoutube(item.externalLink)">
                    <v-divider />
                    <iframe
                      width="100%"
                      height="250"
                      :src="item.externalLink.replace('watch?v=', 'embed/')"
                      :title="item.itemTitle"
                      frameborder="0"
                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    >
                    </iframe>
                  </div>
                  <div v-else>
                    <v-divider />
                    <v-card-actions>
                      <v-chip v-if="getDocType(item.airtableLink)" small
                        ><span v-text="getDocType(item.airtableLink)"
                      /></v-chip>
                      <v-spacer />
                      <v-btn
                        color="secondary"
                        @click="openLink(item)"
                        small
                        round
                        depressed
                        >Abrir</v-btn
                      >
                    </v-card-actions>
                    <v-divider />
                  </div>
                  <v-card-text>
                    <span
                      :class="!isYoutube(item.externalLink) ? 'caption' : ''"
                      >{{ item.itemText }}</span
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    publications: { type: Object },
    selectedPublication: { type: String }
  },
  computed: {
    selectedPublications() {
      return this.publications.publications.filter(
        item => item.group === this.selectedPublication
      )
    }
  },
  methods: {
    openSponsorLink() {
      const url = this.publications.sponsor.link
      window.open(url, '_blank')
    },
    setSelected(selection) {
      this.$emit('update:selectedPublication', selection)
    },
    getIcon(item) {
      if (item.externalLink && this.isYoutube(item.externalLink)) {
        return 'video'
      } else if (item.airtableLink && item.airtableLink.length > 0) {
        return 'atachment'
      } else {
        return 'dashboard'
      }
    },
    getDocType(link) {
      if (link[0] && link[0].type.includes('pdf')) {
        return 'pdf'
      } else if (link[0] && link[0].type.includes('presentation')) {
        return 'powerpoint'
      }
    },
    isYoutube(link) {
      return !!link && link.includes('youtube')
    },
    openLink(item) {
      if (item.airtableLink.length) {
        const url = _.first(item.airtableLink).url
        window.open(url, '_blank')
      } else if (item.externalLink) {
        window.open(item.externalLink, '_blank')
      }
    }
  }
}
</script>

<style></style>
